import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = 'tdt_session_id';

function getSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

/** Fires a lightweight POST /api/visits whenever the route changes. */
export default function VisitTracker() {
  const location = useLocation();
  useEffect(() => {
    // Skip tracking when on the admin area
    if (location.pathname.startsWith('/admin')) return;
    const session_id = getSessionId();
    const referrer = document.referrer && !document.referrer.startsWith(window.location.origin) ? document.referrer : '';
    axios.post(`${API}/visits`, { path: location.pathname, session_id, referrer }).catch(() => {});
  }, [location.pathname]);
  return null;
}
